module.exports = __webpack_public_path__ + "static/media/male05.5f9b8424.jpg";